<template>
  <div class="footer">
    <!-- <a-divider /> -->
    <footer>
      <p>版权所有Copyright © 浙江大学校医院</p>
      <a class="backstage" @click="toBackstage">后台管理系统</a>
      <!-- <p>
        <span>营业执照 食品经营许可证 医疗器械网络销售备案信息</span>
        <span>增值电信业务经营许可证（互联网信息服务</span>
        <span
          >第二类医疗器械经营备案凭证编号：浙杭食药监械经营备20193436号</span
        >
      </p>
      <p>
        <span>增值电信业务经营许可证（第二类增值电信业务）</span>
        <span>互联网药品信息服务资格证编号：（浙）-经营性-2020-0077</span>
        <span>广播电视节目制作经营许可证 网络信息服务信用承诺书 </span>
      </p>
      <p>
        <span>浙ICP备19014363号-2 </span>
        <span>浙公网安备 33010902000463号</span>
      </p> -->
    </footer>
  </div>
</template>

<script>
export default {
  methods: {
    handleJump() {
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    toBackstage() {
      window.open(`https://xyszyl.zju.edu.cn/medical/management/`)
    },
  }
}
</script>

<style lang="scss" scoped>
footer {
  margin: 20px 0;
  padding: 20px;
  text-align: center;
  height: 86px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  line-height: 22px;
  color: #999;
  background: #F8F8F8;

  span {
    margin: 0 8px;
  }
  a{
    color: #999;
  }
  a:hover{
    color: #3F86FF;
  }
}
</style>
